import { useState, useEffect } from "react";

import Paper from "@mui/material/Paper";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// Prop types for TypeScript callers. @types/react 19 no longer reads `propTypes`,
// and React 19 ignores them at runtime.
/**
 * @param {object} props
 * @param {boolean} [props.expanded]
 * @param {import("react").ReactNode} [props.children]
 * @param {import("react").ReactNode} [props.title]
 * @param {string} [props.navId]
 * @param {(expanded: boolean) => void} [props.onChange]
 * @param {import("@mui/material").SxProps<import("@mui/material").Theme>} [props.summarySx]
 */
const ExpandableSection = ({ expanded = false, children, title, navId, onChange, summarySx }) => {
  const [isExpanded, setIsExpanded] = useState(expanded);

  // Update internal state when expanded prop changes
  useEffect(() => {
    setIsExpanded(expanded);
  }, [expanded]);

  const handleChange = (e, value) => {
    setIsExpanded(value);
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <Paper {...(navId ? { id: navId } : {})} variant="outlined" style={{ marginBottom: "0.5rem" }} elevation={0}>
      <Accordion expanded={isExpanded} onChange={handleChange}>
        {/* A div, not MUI's default native <button>: titles can contain their own buttons and
            links (e.g. the unassign action in AircraftSection), and buttons must not nest. */}
        {title && (
          <AccordionSummary component="div" expandIcon={<ExpandMoreIcon />} sx={summarySx}>
            {title}
          </AccordionSummary>
        )}
        <AccordionDetails style={{ padding: 0, border: 0 }}>{children}</AccordionDetails>
      </Accordion>
    </Paper>
  );
};

export default ExpandableSection;
